<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/MsWUUV/tc-custom/9781626811874.jpg?1702083506006" alt="This image is the cover for the book Forbidden Moon, The Moon Trilogy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Forbidden Moon, The Moon Trilogy
      </h1>
      <p class="bookDescription body article font2">
        <b>A childhood promise is kept when an old crush blossoms into blazing passion in this spellbinding historical romance set in the old West.</b><br/>  <br/><i>San Francisco, 1886</i>. When Buck Randall met Molly Lindquist, he knew she was the only woman he would ever love. Only a girl when they met, the prideful Buck promised to wait for her until she is old enough to become his.<br/>  <br/> As an adult, Molly is looking for her ticket out of a life that she hates. Engaged to a powerful Texas rancher, she’s all but forgotten the pact she made as a child. But when Buck returns to her life, a romance is rekindled that burns too brightly to ignore, and a promise must be kept—at all costs . . .<br/>  <br/> “Jane Bonander reaches to her readers’ hearts.” —<i>RT Book Reviews</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jane Bonander
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Diversion Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?761ed6b0